import { fuseProvisioningEventsConstants } from "../_redux-constants";

export function fuseProvisioningEventsReducer(
  state = {
    fuseprovisioningEventsLoading: false,
    fuseprovisioningEventsData: null,
    fuseprovisioningEventsError: null,
  },
  action
) {
  switch (action.type) {
    case fuseProvisioningEventsConstants.FUSE_PROVISIONING_EVENTS_LOADING:
      return Object.assign({}, state, {
        fuseprovisioningEventsLoading: true,
        fuseprovisioningEventsData: null,
        fuseprovisioningEventsError: null,
      });
    case fuseProvisioningEventsConstants.FUSE_PROVISIONING_EVENTS_SUCCESS:
      return Object.assign({}, state, {
        fuseprovisioningEventsLoading: false,
        fuseprovisioningEventsData: action.data,
        fuseprovisioningEventsError: null,
      });
    case fuseProvisioningEventsConstants.FUSE_PROVISIONING_EVENTS_FAILURE:
      return Object.assign({}, state, {
        fuseprovisioningEventsLoading: false,
        fuseprovisioningEventsData: null,
        fuseprovisioningEventsError: action.error,
      });
    default:
      return state;
  }
}
